module.exports = __webpack_public_path__ + "img/semed_logo.6fd832ab.png";